import Button from '../button/index.vue';
import Tab from '../tab/index.vue';
import Checkbox from '../checkbox/index.vue';
import Radio from '../radio/index.vue';
import Select from '../select/index.vue';
import Breadcrumb from '@/components/layout/breadcrumb/index.vue';
import Modal from '@/components/ui/modal/index.vue';
import Dropdown from '../dropdown/index.vue';
import Switcher from '../switcher/index.vue';
import Cardimg from '../cardimg/index.vue';
import Slidebar from '../slidebar/index.vue';
import CircleChart from '../circlechart/index.vue';
import Pagination from '../pagination/index.vue';
import LineBar from '../linebar/index.vue';
import ProgressBar from '../progressbar/index.vue';
import CollapseMultiSelect from '../collapsemutiselect/index.vue';
import CardInfo from '../cardinfo/index.vue';
import ActionBar from '../actionbar/index.vue';
import Table from '../tablebox/index.vue';
import TableInfo from '../tableinfo/index.vue';
import CTmenu from '../ctmenu/index.vue';
import Input from '../input/index.vue';
import ContentGroup from '../contentgroup/index.vue';
import Textarea from '../textarea/index.vue';
import { reactive, computed, onMounted, watch,ref  } from 'vue';
import { useStore } from 'vuex';
import { POPUP, BTN } from '@/enum/enum';
import { apiGetDevice } from '@/api/api';
import Timer from '@/components/ui/timer/index.vue';
import FlashMsg from '@/components/ui/flashMsg/index.vue';
import Loading from '@/components/ui/loading/index.vue';

import multiSelect from '../multiselect/index.vue';
import DatePickerLocal from '@/components/ui/datePicker/index.vue';

import * as moment from 'moment';
import DatePicker from 'vue-datepicker-next';



export default {
  components: {
    Button,
    Tab,
    Checkbox,
    Radio,
    Select,
    Breadcrumb,
    Modal,
    Dropdown,
    Switcher,
    Cardimg,
    Slidebar,
    CircleChart,
    Pagination,
    ProgressBar,
    CollapseMultiSelect,
    CardInfo,
    LineBar,
    ActionBar,
    Table,
    TableInfo,
    CTmenu,
    ContentGroup,
    Input,
    Textarea,
    Timer,
    FlashMsg,
    Loading,
    DatePicker,
    DatePickerLocal,
    multiSelect
  },
  props: {

  },
  setup() {
    const state = reactive({
      ttt : [new Date(2019, 9, 8), new Date(2022, 10, 10)],
      tttt: new Date(2019, 9, 8),
      temp : [],
      open: false,
      time0: null,
      time1: null,
      isLoading: false,
      position: {
        x: 0,
        y: 0,
      },
      columns: [
        {
          title: null,
          key: null,
        },
        {
          title: "Brightness",
          key: "brightness",
        },
        {
          title: "Color Temperature",
          key: "colorTemperature"
        },
        {
          title: "Gamma",
          key: "gamma",
        }
      ],

      tempData: [],  //選擇modal list 的暫存陣列
      dataToMulti: [], //綁定進去複合式版型的list
      disList: [true, true, false, false, false],
      data: [ //假設 modal 有的 list
        {
          name: 'SN-0123456789',
          val: 'SN-0123456789',
        },
        {
          name: '111',
          val: '111',
        },
        {
          name: '222',
          val: '222',
        },
        {
          name: '333',
          val: '333',
        },
        {
          name: '444',
          val: '444',
        },
        {
          name: '555',
          val: '555',
        },
        {
          name: '666',
          val: '666',
        },
        {
          name: '777',
          val: '777',
        },
      ],
      isShowModal: false,
      isCheck: false,
      selectedVal: 'val003',
      op222:[
        {
          text: '111',
          val: '1111'
        },
        {
          text: '222',
          val: '2222'
        }
      ],
      op: [{
        text: '1-001<a style="color:red">test</a>',
        val: '001',
      },
      {
        text: '1-002',
        val: '002',
        sub: [{
          text: '2-00001',
          val: '00201'
        },
        {
          text: '2-00001',
          val: '00202'
        }]
      },
      {
        text: '1-003',
        val: '003',
        sub: [{
          text: '3-00001',
          val: '00301'
        },
        {
          text: '3-00001',
          val: '00302'
        }]
      },
      ],
      selectVal: {
        text: '請選擇',
        val: 'default',
      },
      testtt: {
        text: '請選擇',
        val: 'default',
      },
      defaultSelect: {
        text: '請選擇',
        val: 'default',
      },
      multiSelectVal: [
        {
          text: '1-001<a style="color:red">test</a>',
          val: '001',
        },
        {
          text: '1-002',
          val: '002',
        },
        {
          text: '1-003',
          val: '003',
        },
        {
          text: '在這一連串資料下取得 value 之特性屬性的陣列',
          val: '004',
        },
        {
          text: '一個陣列包含了一串物件',
          val: '005',
        },
        {
          text: '取得特性屬性值的陣列',
          val: '006',
        },
      ],
      isOpenNormalModal: false,
      data_up1: ["Ungroup only", "Ungroup and unbind all", "Devices together"],
      data_up2: ["Add Device", "Rename Group Name"],
      data_down2: ["Ungroup only", "Ungroup and unbind all", "Devices together"],
      isSwitcher1: true,
      isSwitcher2: false,
      gamma: ["0.8", "2.0", "2.2", "2.4", "2.6"],
      color: ["5000", "6500", "9300"],
      brightness: ["50"],
      cardimg_click: false,
      chart: [
        {
          name: "Within 3 month",
          color: "#EBEBEB",
          amount: 20
        },
        {
          name: "Within 3-6 month",
          color: "#a7a8ac",
          amount: 21
        },
        {
          name: "Within 6-12 month",
          color: "#FCD9AF",
          amount: 30
        },
        {
          name: "Over 1 year",
          color: "#000000",
          amount: 23
        },
      ],
      meta: {
        total_page: 20,
        current: 1,

      },
      LineData: [
        {
          name: "Success",
          color: "#FCD9AF",
          value: 25
        },
        {
          name: "Fail",
          color: "#ff0000",
          value: 25
        },
        {
          name: "Retest",
          color: "#ddaa00",
          value: 10
        },
        {
          name: "Fail",
          color: "#00dada",
          value: 5
        },
      ],
      progress: 0,
      isOpenImageModal: false, //開啟有圖的modal
      confirmBtnSetting: {
        text: 'Confirm',
        disable: false,
        theme: '3',
        color: 'main-gradient',
        type: 'full',
        wd: 'sm'
      },
      sliderdata: [2000, 3000, 7000, 8000, 9000, 10000],
      inputVal: 'aaa',
      isInputError: false,
      isInputDisable: false,
      isSelectError: false,
      isSelectDisable: true,
      modalGetData: '',
      isStart: false,
      time: 360000,
      isOpenFlashMsg: true,

    });

    const data = reactive([ //假設 modal 有的 list
      {
        name: 'SN-0123456789',
        val: 'SN-0123456789',
      },
      {
        name: '111',
        val: '111',
        eee: 'EEE',
        ooo: 'OOO',
      },
      {
        name: '222',
        val: '222',
        eee: 'CCC',
        ooo: 'VVV',
      },
      {
        name: '333',
        val: '333',
        eee: 'EEE',
        ooo: 'IIII',
      },
      {
        name: '444',
        val: '444',
        eee: 'PPP',
        ooo: 'JJJ',
      },
      {
        name: '555',
        val: '555',
        eee: 'LLL',
        ooo: 'MMM',
      },
      {
        name: '666',
        val: '666',
        eee: 'LLL',
        ooo: 'HHH',
      },
      {
        name: '777',
        val: '777',
        eee: 'EBEBEB',
        ooo: 'EBEBEB',
      },
    ])

    

    const onClickTab = (v) => {
      console.log(v, 'onClickTab')
    };
    const menuSetting = (v) => {
      console.log(v, 'menuSetting')
    };
    const selectContextMenu = (v) => {
      console.log(v, 'show not in table')
    };
    const showCTAndRow = (v) => {
      console.log(v, 'showContextMenu and row')
    };
    const goTableLink = (v) => {
      console.log(v, 'table link')
    };
    const onCheckEach = (v) => {
      console.log(v, 'table onCheckEach')
    };
    const onCheckAll = (v) => {
      console.log(v, 'table onCheckAll')
    };
    const tableSort = (v) => {
      console.log(v, 'sort table')
    };
    const applyCalibration = (data) => {
      console.log('applyToCalibration', data)
    };
    const progressAdd = () => { //demo 使用
      const test = setInterval(() => {
        if (state.progress < 100) {
          state.progress += 10;
        } else {
          clearInterval(test);
        }
      }, 600);

    };
    const testConsole = () => {
      alert('click test console');
    };
    const openModalNorma = () => {

    };
    const dropdown = (e) => {
      alert(e);
    };
    const changePage = (page) => {
      console.log(page,'now page')
      state.meta.current = page;
    };
    const setUnbind = (e) => {
      console.log(e, 'setUnbind')
    };
    const setCalibration = (e) => {
      console.log(e, 'setCalibration')
    };
    const showModal = (e) => {
      state.isShowModal = e
    };
    const modalAddItem = () => {
      state.dataToMulti = state.tempData.map((i) => { return i })
      state.isShowModal = false
      state.tempData = []
    };
    const modalCancel = () => {
      state.isShowModal = false
      state.tempData = []
    };
    const chooseItem = (e) => {
      state.tempData.push(e)
    };
    const openContextMenu = () => {
      state.position.x += 1
      state.position.y += 1
      console.log('content menu test')
    };




    //picker

    const applyDate = (emit) => {
      // console.log('e',emit)
      emit(state.temp)
      state.temp = []
      //confirm="true" confirm-text="Apply"
      
    };
    const datePickerConfirm = (e) => {
      console.log('e',e)
      //confirm="true" confirm-text="Apply"
    };

    const closePicker = () => {
      state.temp = []
      state.open = false
      
    };

    const timePick = (e) => {
      if(e){
        return moment(e).format('YY/MM/DD')
      }else{
         return ''
      }
    }

    const calendarChange = (e) => {
      if(state.temp.length){
        if(state.temp.length==1){
          if(e > state.temp[0]){
            state.temp.splice(0+1,0,e);
          }else{
            state.temp.splice(0-1,0,e);
          }
        }else{
          state.temp = []
          state.temp .push(e)
        }
      }else{
        state.temp .push(e)
      }
      console.log('state.temp ',state.temp )
      //confirm="true" confirm-text="Apply"
      
    };


    const changeDatePicker = (e) => {
      console.log('??', e)
      state.ttt = e
    }
    

    //picker


    const datePicker = ref();
    const range = computed(() => state.meta.total_page < 5 ? state.meta.total_page : 5);

    onMounted(() => {
      progressAdd();
      getAPIData();
    })

    // demo api
    const getAPIData = async () => {
      try {
        const data = await apiGetDevice();
        console.log('api data', data);
      }
      catch (err) {
        console.log('err')
      }
    }

    // demo modal 使用方法
    const store = useStore();
    const storeState = store.state;
    const showModalGlobal = () => {
      const modalConfig = {
        type: POPUP.DEMO,
        data: ['AAAA', 'BBB', 'CCCC'],
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }

    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.DEMO) {
        console.log('toreState.modalBtnType', storeState.modalBtnType);
        // modal btn type
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          console.log('confirm');
          const output = storeState.modalOutput
          state.modalGetData = output + '-modifyBy';
        }
      } //end: modal
    })

    const showModalGlobal2 = () => {
      const modalConfig = {
        type: POPUP.NORMAL,
        data: '',
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }

    const btnInfo = reactive({
      checkItem: [false, false, false],
      disable: false,
      checkNum: 0,
    })

    watch(
      () => btnInfo.checkItem,
      (val) => {
        let isAllTrue = !val.includes(false);
        btnInfo.disable = isAllTrue;
        btnInfo.checkNum = val.filter(item => item).length;
      },
      { deep: true }
    )//end: watch 

    const finshTimer = () => {
      console.log('finshTimer');
    }



    const openFlashMsg = () => {
      console.log('openFlashMsg');
      state.isOpenFlashMsg = true;
    }






    return {
      state,
      openContextMenu,
      chooseItem,
      modalCancel,
      modalAddItem,
      showModal,
      setCalibration,
      setUnbind,
      changePage,
      dropdown,
      openModalNorma,
      onClickTab,
      menuSetting,
      selectContextMenu,
      showCTAndRow,
      goTableLink,
      onCheckEach,
      onCheckAll,
      tableSort,
      applyCalibration,
      progressAdd,
      testConsole,
      range,
      data,
      showModalGlobal,
      showModalGlobal2,
      btnInfo,
      finshTimer,
      openFlashMsg,
      datePicker,
      applyDate,
      datePickerConfirm,
      calendarChange,
      closePicker,
      timePick,
      changeDatePicker

    }
  }
}

